import type { Language } from "./translations";

const copy = {
  "no": {
    "callback": "Be oss ringe deg",
    "headline": "Sertifisert oversettelse mellom thai og norsk — for par, familier og alle med thailandske dokumenter",
    "intro": "Vi oversetter dokumenter på thai, norsk og engelsk og veileder deg gjennom prosessen med thailandske eller norske myndigheter — enten du er søker, ektefelle, partner eller pårørende. Du får hjelp av et thai-drevet team med en representant i Norge.",
    "badge": "Thai-drevet team · Representant i Norge",
    "reassurance": "Vi ringer deg innen 24 timer. Gratis og uforpliktende.",
    "formIntro": "Oppgi navn, nummer og hvilke dokumenter du trenger hjelp med. Vi ringer deg for å avklare resten.",
    "name": "Fullt navn",
    "namePlaceholder": "Ditt fulle navn",
    "phone": "Telefon- eller WhatsApp-nummer",
    "documents": "Hvilke dokumenter trenger du hjelp med?",
    "documentsPlaceholder": "For eksempel vigselsattest, skilsmissepapirer eller dokumenter for en forelder. Beskriv gjerne hvis du er usikker.",
    "direction": "Oversettelsesretning",
    "directions": [
      "Thai → Norsk",
      "Norsk → Thai"
    ],
    "more": "Flere detaljer (valgfritt)",
    "email": "E-postadresse",
    "country": "Nåværende bosted",
    "countries": [
      "Norge",
      "Flytter til Norge",
      "Annet"
    ],
    "visa": "Visum/oppholdstype",
    "visas": [
      "Familieinnvandring",
      "Ektefellevisum",
      "Arbeidstillatelse",
      "Statsborgerskap",
      "Annet"
    ],
    "select": "Velg (valgfritt)…",
    "category": "Dokumentkategori",
    "categories": [
      "Ekteskap",
      "Familiegjenforening",
      "Fødsels/ID",
      "Juridisk",
      "Annet"
    ],
    "count": "Antall dokumenter",
    "urgent": "Haster (48t ekspresslevering)",
    "specific": "Spesifikke dokumenter",
    "docOptions": [
      "Fødselsattest",
      "Vigselsattest",
      "Vandelsattest",
      "Vitnemål/utdanning",
      "Bankutskrift",
      "Annet"
    ],
    "upload": "Last opp dokumenter (valgfritt, maks 5 filer)",
    "uploadButton": "Velg filer",
    "remove": "Fjern fil",
    "message": "Melding / tilleggsinformasjon",
    "messagePlaceholder": "Har du spørsmål eller mer informasjon?",
    "sending": "Sender…",
    "error": "Vi kunne ikke sende forespørselen. Prøv igjen, eller kontakt oss på WhatsApp.",
    "success": "Takk! Vi ringer deg innen 24 timer.",
    "successBody": "Vi avklarer dokumentene sammen, avtaler pris og forklarer de neste stegene. Du betaler først etter at vi har avtalt prisen.",
    "back": "Tilbake til forsiden",
    "whatsappLine": "Foretrekker du WhatsApp?",
    "trustHeading": "Erfaring og personlig hjelp",
    "stats": [
      "Søknader",
      "Års erfaring",
      "Godkjent av UDI"
    ],
    "team": "Thai-drevet team",
    "teamBody": "Du kan snakke med et thai-drevet team, med en representant i Norge.",
    "address": "Ved Thailands ambassade i Oslo",
    "appointment": "Hausmanns gate 7, 0186 Oslo. Besøk kun etter avtale.",
    "disclaimer": "Kravene avhenger av saken din. Vi oversetter og veileder; myndighetene avgjør søknaden.",
    "steps": [
      [
        "Send skjemaet",
        "Fortell oss hvilke dokumenter du trenger hjelp med."
      ],
      [
        "Vi ringer deg",
        "Vi kontakter deg innen 24 timer for å avklare behovet."
      ],
      [
        "Vi avtaler pris",
        "Du får vite prisen før du bestemmer deg."
      ],
      [
        "Betal via bankoverføring",
        "Når prisen er avtalt, betaler du via bankoverføring."
      ],
      [
        "Vi leverer og hjelper",
        "Du får oversettelsene og veiledning i den videre prosessen."
      ]
    ],
    "ctaHeading": "Trenger du hjelp med dokumentene?",
    "ctaSub": "For deg selv eller en i familien — vi avklarer hva du trenger når vi ringer deg.",
    "contactRole": "Hvem kontakter oss?",
    "contactRoles": [
      "Jeg er søkeren",
      "Jeg er ektefelle eller partner",
      "Jeg er pårørende",
      "Annet"
    ],
    "homeText": {
      "guarantee.heading": "Sertifisert oversettelse og veiledning",
      "guarantee.text": "Vi oversetter dokumenter på thai, norsk og engelsk og hjelper deg gjennom prosessen med thailandske og norske myndigheter. Kravene avhenger av saken din.",
      "why.1.desc": "Vi har spesialisert oss på dokumentoversettelse på thai, norsk og engelsk.",
      "services.translation.desc": "Sertifisert oversettelse av dokumenter på thai, norsk og engelsk.",
      "services.review.title": "Dokumentgjennomgang",
      "services.review.desc": "Vi hjelper deg å avklare hvilke dokumenter du trenger for saken din.",
      "docs.subtitle": "Oversettelse av dokumenter til bruk hos thailandske og norske myndigheter. Kravene avhenger av saken din.",
      "about.heading": "Vi forstår språkene og situasjonen din",
      "about.body": "Vårt thai-drevne team har en representant i Norge. Vi hjelper søkere, ektefeller, partnere og pårørende med oversettelse og veiledning i kontakten med thailandske og norske myndigheter.",
      "about.bullet2": "Dokumenthjelp for kontakt med thailandske og norske myndigheter",
      "faq.5.q": "Kan jeg kontakte dere på vegne av en partner eller et familiemedlem?",
      "faq.5.a": "Ja. Vi hjelper både søkere, ektefeller, partnere og pårørende, uansett nasjonalitet. Du kan kontakte oss på thai, norsk eller engelsk.",
      "footer.tagline": "Sertifisert oversettelse på thai, norsk og engelsk for par, familier og kontakt med thailandske eller norske myndigheter."
    }
  },
  "en": {
    "callback": "Request a call back",
    "headline": "Certified Thai–Norwegian document translation, for couples and families",
    "intro": "We translate Thai, Norwegian and English documents and guide you through the process with Thai or Norwegian authorities — whether you are the applicant, spouse, partner or a relative. Our Thai-run team has a representative in Norway.",
    "badge": "Thai-run team · Representative in Norway",
    "reassurance": "We call you within 24 hours. Free and no obligation.",
    "formIntro": "Tell us your name, number and which documents you need help with. We’ll call to discuss the rest.",
    "name": "Full name",
    "namePlaceholder": "Your full name",
    "phone": "Phone or WhatsApp number",
    "documents": "Which documents do you need help with?",
    "documentsPlaceholder": "For example, a marriage certificate, divorce papers or documents for a parent. Describe what you need if you’re unsure.",
    "direction": "Translation direction",
    "directions": [
      "Thai → Norwegian",
      "Norwegian → Thai"
    ],
    "more": "More details (optional)",
    "email": "Email address",
    "country": "Current residence",
    "countries": [
      "Norway",
      "Moving to Norway",
      "Other"
    ],
    "visa": "Visa / residence type",
    "visas": [
      "Family immigration",
      "Spouse visa",
      "Work permit",
      "Citizenship",
      "Other"
    ],
    "select": "Select (optional)…",
    "category": "Document category",
    "categories": [
      "Marriage",
      "Family reunification",
      "Birth/ID",
      "Legal",
      "Other"
    ],
    "count": "Number of documents",
    "urgent": "Urgent (48h express delivery)",
    "specific": "Specific documents",
    "docOptions": [
      "Birth certificate",
      "Marriage certificate",
      "Criminal record",
      "Diploma/education",
      "Bank statement",
      "Other"
    ],
    "upload": "Upload documents (optional, max 5 files)",
    "uploadButton": "Choose files",
    "remove": "Remove file",
    "message": "Message / additional information",
    "messagePlaceholder": "Any questions or additional information?",
    "sending": "Sending…",
    "error": "We couldn’t send your request. Please try again or contact us on WhatsApp.",
    "success": "Thank you! We’ll call you within 24 hours.",
    "successBody": "We’ll discuss your documents, agree a price and explain the next steps. You pay only after we agree the price.",
    "back": "Back to home",
    "whatsappLine": "Prefer WhatsApp?",
    "trustHeading": "Experience and personal support",
    "stats": [
      "Applications",
      "Years of experience",
      "Approved by UDI"
    ],
    "team": "A Thai-run team",
    "teamBody": "Talk to a Thai-run team with a representative in Norway.",
    "address": "Beside the Thai embassy in Oslo",
    "appointment": "Hausmanns gate 7, 0186 Oslo. Visits by appointment only.",
    "disclaimer": "Requirements depend on your case. We translate and guide you; the authorities decide on applications.",
    "steps": [
      [
        "Send the form",
        "Tell us which documents you need help with."
      ],
      [
        "We call you",
        "We call within 24 hours to discuss your needs."
      ],
      [
        "Agree the price",
        "Know the price before deciding."
      ],
      [
        "Pay by bank transfer",
        "Once we agree the price, pay by bank transfer."
      ],
      [
        "We deliver and help",
        "Receive your translations and guidance through the next steps."
      ]
    ],
    "ctaHeading": "Need help with your documents?",
    "ctaSub": "For you or a family member — we’ll discuss what you need when we call.",
    "contactRole": "Who is contacting us?",
    "contactRoles": [
      "I am the applicant",
      "I am the spouse or partner",
      "I am a relative",
      "Other"
    ],
    "homeText": {
      "guarantee.heading": "Certified translation and guidance",
      "guarantee.text": "We translate Thai, Norwegian and English documents and guide you through dealings with Thai and Norwegian authorities. Requirements depend on your case.",
      "why.1.desc": "We specialize in document translation in Thai, Norwegian and English.",
      "services.translation.desc": "Certified translation of Thai, Norwegian and English documents.",
      "services.review.title": "Document review",
      "services.review.desc": "We help you clarify which documents you need for your case.",
      "docs.subtitle": "Document translation for Thai and Norwegian authorities. Requirements depend on your case.",
      "about.heading": "We understand the languages and your situation",
      "about.body": "Our Thai-run team has a representative in Norway. We help applicants, spouses, partners and relatives with translation and guidance when dealing with Thai and Norwegian authorities.",
      "about.bullet2": "Document support for dealings with Thai and Norwegian authorities",
      "faq.5.q": "Can I contact you on behalf of a partner or family member?",
      "faq.5.a": "Yes. We help applicants, spouses, partners and relatives, regardless of nationality. You can contact us in Thai, Norwegian or English.",
      "footer.tagline": "Certified Thai, Norwegian and English translation for couples, families and dealings with Thai or Norwegian authorities."
    }
  },
  "th": {
    "callback": "ให้เราโทรกลับ",
    "headline": "แปลเอกสารไทย–นอร์เวย์ พร้อมคำรับรองการแปล สำหรับคู่รักและครอบครัว",
    "intro": "เราแปลเอกสารภาษาไทย นอร์เวย์ และอังกฤษ พร้อมแนะนำทุกขั้นตอนในการติดต่อหน่วยงานไทยหรือนอร์เวย์ ไม่ว่าคุณจะเป็นผู้ยื่นคำขอ คู่สมรส คู่ชีวิต หรือญาติ ดูแลโดยทีมงานคนไทยที่มีตัวแทนในนอร์เวย์",
    "badge": "ทีมงานคนไทย · มีตัวแทนในนอร์เวย์",
    "reassurance": "เราโทรกลับภายใน 24 ชั่วโมง ฟรี ไม่มีข้อผูกมัด",
    "formIntro": "กรอกชื่อ เบอร์ติดต่อ และเอกสารที่ต้องการให้ช่วย เราจะโทรกลับเพื่อสอบถามรายละเอียดเพิ่มเติม",
    "name": "ชื่อและนามสกุล",
    "namePlaceholder": "ชื่อและนามสกุลของคุณ",
    "phone": "เบอร์โทรศัพท์หรือ WhatsApp",
    "documents": "ต้องการให้ช่วยเรื่องเอกสารอะไรบ้าง?",
    "documentsPlaceholder": "เช่น ทะเบียนสมรส เอกสารการหย่า หรือเอกสารของคุณพ่อคุณแม่ หากไม่แน่ใจ เล่าให้เราฟังได้",
    "direction": "ภาษาที่ต้องการแปล",
    "directions": [
      "ไทย → นอร์เวย์",
      "นอร์เวย์ → ไทย"
    ],
    "more": "รายละเอียดเพิ่มเติม (ไม่บังคับ)",
    "email": "อีเมล",
    "country": "ปัจจุบันอาศัยอยู่ที่ไหน",
    "countries": [
      "นอร์เวย์",
      "กำลังย้ายไปนอร์เวย์",
      "อื่น ๆ"
    ],
    "visa": "ประเภทวีซ่าหรือการพำนัก",
    "visas": [
      "การย้ายไปอยู่กับครอบครัว",
      "วีซ่าคู่สมรส",
      "ใบอนุญาตทำงาน",
      "การขอสัญชาติ",
      "อื่น ๆ"
    ],
    "select": "เลือก (ไม่บังคับ)…",
    "category": "หมวดหมู่เอกสาร",
    "categories": [
      "สมรส",
      "การรวมครอบครัว",
      "การเกิด/เอกสารยืนยันตัวตน",
      "กฎหมาย",
      "อื่น ๆ"
    ],
    "count": "จำนวนเอกสาร",
    "urgent": "เร่งด่วน (บริการด่วน 48 ชั่วโมง)",
    "specific": "รายการเอกสาร",
    "docOptions": [
      "สูติบัตร",
      "ทะเบียนสมรส",
      "ใบรับรองความประพฤติ",
      "วุฒิการศึกษา",
      "รายการเดินบัญชี",
      "อื่น ๆ"
    ],
    "upload": "อัปโหลดเอกสาร (ไม่บังคับ สูงสุด 5 ไฟล์)",
    "uploadButton": "เลือกไฟล์",
    "remove": "ลบไฟล์",
    "message": "ข้อความหรือข้อมูลเพิ่มเติม",
    "messagePlaceholder": "มีคำถามหรือข้อมูลเพิ่มเติมไหม?",
    "sending": "กำลังส่ง…",
    "error": "ส่งคำขอไม่สำเร็จ กรุณาลองอีกครั้ง หรือติดต่อเราทาง WhatsApp",
    "success": "ขอบคุณค่ะ! เราจะโทรกลับภายใน 24 ชั่วโมง",
    "successBody": "เราจะพูดคุยเรื่องเอกสาร ตกลงราคา และอธิบายขั้นตอนต่อไป คุณชำระเงินหลังจากตกลงราคากันแล้วเท่านั้น",
    "back": "กลับหน้าแรก",
    "whatsappLine": "สะดวกติดต่อทาง WhatsApp มากกว่า?",
    "trustHeading": "ประสบการณ์และการดูแลอย่างใกล้ชิด",
    "stats": [
      "คำขอที่ดูแลแล้ว",
      "ปีแห่งประสบการณ์",
      "ได้รับอนุมัติจาก UDI"
    ],
    "team": "ดูแลโดยทีมงานคนไทย",
    "teamBody": "พูดคุยกับทีมงานคนไทย พร้อมตัวแทนในนอร์เวย์ที่ช่วยดูแลคุณ",
    "address": "ข้างสถานทูตไทยในออสโล",
    "appointment": "Hausmanns gate 7, 0186 Oslo กรุณานัดหมายก่อนเข้าพบ",
    "disclaimer": "ข้อกำหนดขึ้นอยู่กับแต่ละกรณี เราแปลเอกสารและให้คำแนะนำ ส่วนการพิจารณาคำขอเป็นหน้าที่ของหน่วยงานที่เกี่ยวข้อง",
    "steps": [
      [
        "ส่งแบบฟอร์ม",
        "แจ้งเอกสารที่ต้องการให้เราช่วยดูแล"
      ],
      [
        "เราโทรกลับ",
        "เราติดต่อกลับภายใน 24 ชั่วโมงเพื่อพูดคุยสิ่งที่คุณต้องการ"
      ],
      [
        "ตกลงราคา",
        "ทราบราคาก่อนตัดสินใจใช้บริการ"
      ],
      [
        "ชำระผ่านการโอนเงิน",
        "เมื่อเราตกลงราคากันแล้ว คุณชำระเงินผ่านธนาคาร"
      ],
      [
        "ส่งงานและช่วยดูแลต่อ",
        "รับเอกสารแปล พร้อมคำแนะนำสำหรับขั้นตอนต่อไป"
      ]
    ],
    "ctaHeading": "ต้องการความช่วยเหลือเรื่องเอกสารไหม?",
    "ctaSub": "ไม่ว่าจะเป็นเอกสารของคุณหรือคนในครอบครัว เราจะโทรกลับเพื่อช่วยดูว่าต้องเตรียมอะไรบ้าง",
    "contactRole": "คุณติดต่อเราในฐานะใด?",
    "contactRoles": [
      "ฉันเป็นผู้ยื่นคำขอ",
      "ฉันเป็นคู่สมรสหรือคู่ชีวิต",
      "ฉันเป็นญาติ",
      "อื่น ๆ"
    ],
    "homeText": {
      "guarantee.heading": "แปลเอกสารพร้อมคำรับรองและคำแนะนำ",
      "guarantee.text": "เราแปลเอกสารภาษาไทย นอร์เวย์ และอังกฤษ พร้อมแนะนำขั้นตอนการติดต่อหน่วยงานไทยและนอร์เวย์ ข้อกำหนดขึ้นอยู่กับแต่ละกรณี",
      "why.1.desc": "เราเชี่ยวชาญด้านการแปลเอกสารภาษาไทย นอร์เวย์ และอังกฤษ",
      "services.translation.desc": "แปลเอกสารภาษาไทย นอร์เวย์ และอังกฤษ พร้อมคำรับรองการแปล",
      "services.review.title": "ตรวจสอบเอกสาร",
      "services.review.desc": "เราช่วยดูว่าคุณต้องเตรียมเอกสารอะไรบ้างสำหรับกรณีของคุณ",
      "docs.subtitle": "แปลเอกสารเพื่อใช้กับหน่วยงานไทยและนอร์เวย์ ข้อกำหนดขึ้นอยู่กับแต่ละกรณี",
      "about.heading": "เราเข้าใจทั้งภาษาและสถานการณ์ของคุณ",
      "about.body": "ทีมงานคนไทยของเรามีตัวแทนในนอร์เวย์ เราช่วยผู้ยื่นคำขอ คู่สมรส คู่ชีวิต และญาติ แปลเอกสารและให้คำแนะนำในการติดต่อหน่วยงานไทยและนอร์เวย์",
      "about.bullet2": "ช่วยดูแลเอกสารสำหรับติดต่อหน่วยงานไทยและนอร์เวย์",
      "faq.5.q": "ติดต่อแทนคู่สมรสหรือคนในครอบครัวได้ไหม?",
      "faq.5.a": "ได้ค่ะ เราช่วยทั้งผู้ยื่นคำขอ คู่สมรส คู่ชีวิต และญาติ ไม่ว่าจะเป็นสัญชาติใด ติดต่อเราได้เป็นภาษาไทย นอร์เวย์ หรืออังกฤษ",
      "footer.tagline": "แปลเอกสารภาษาไทย นอร์เวย์ และอังกฤษ พร้อมคำรับรองการแปล สำหรับคู่รัก ครอบครัว และการติดต่อหน่วยงานไทยหรือนอร์เวย์"
    }
  }
};

export const conversionCopy: Record<Language, (typeof copy)["no"]> = copy;
